import { render } from "./GoogleAuthenticator.vue?vue&type=template&id=48750723&scoped=true"
import script from "./GoogleAuthenticator.vue?vue&type=script&lang=js"
export * from "./GoogleAuthenticator.vue?vue&type=script&lang=js"

import "./GoogleAuthenticator.vue?vue&type=style&index=0&id=48750723&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48750723"]])

export default __exports__